import styled from "styled-components";

export const IndexPageStyled = styled.div`
    padding: 16px 0;
`;

export const IndexPageRowStyled = styled.div`
    margin-bottom: 21px;

    &:last-child {
        margin: 0;
    }
`;

export const IndexPageRowTitleStyled = styled.p`
    font-weight: 700;
    font-size: 18px;
    line-height: 1.25;
    margin-bottom: 16px;
    padding-left: 24px;
`;

export const IndexPageRowTrackStyled = styled.div`
    display: flex;
    height: 233px;
    overflow-x: auto;
    gap: 16px;
    max-width: 100vw;
    padding-bottom: 16px;

    &::after {
        content: "";
        display: block;
        min-width: 42px;
        max-width: 42px;
        height: 100%;
    }

    button {
        &:active {
            transform: scale(0.966);
            transition: transform .15s;

            p {
                opacity: 0.3;
                transition: opacity .15s;
            }
        }
    }
`;

export const IndexPageBlockButtonContainerStyled = styled.div`
    &.animation-start {
        animation-play-state: running;

        * {
            animation-play-state: running !important;
        }
    }

    ${props => !props.isDesktop && `
        &.animation-end {
            animation: none;
            animation-play-state: running;

            *:not(.touch-effect *) {
                animation: none !important;
                animation-play-state: running !important;
            }

            .blur-row:nth-child(2) {
                opacity: 1;
            }
        }
    `}
`;

export const IndexPageBlockButtonStyled = styled.button`
    @keyframes scrollVertical {
        to {
            background-position-y: -4030px;
        }
    }

    @keyframes scrollHorizontal {
        from {
            background-position-x: 0;
        }

        to {
            background-position-x: calc(1500vw + 80px);
        }
    }

    position: relative;
    background: transparent;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 10px;
    overflow: hidden;
    transform: translateZ(0);
    will-change: transform;
    height: 100%;
    //min-width: 35vw;
    min-width: 175px;
    max-width: 175px;

    &:first-child {
        margin-left: 24px;
    }

    // &:last-child {
    //     margin-right: 58px;
    // }
    
    .pro-label {
        position: absolute;
        top: 0;
        left: 0;
        background: #f4c500;
        font-weight: 700;
        z-index: 10;
        padding: 3px 5px;
        border-radius: 0 0 10px 0;
    }

    ${props => props.type === "wide" && `
        min-width: 300px;
        max-width: 300px;
    `}

    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 50%);
        pointer-events: none;
    }

    ${props => !props.isDesktop && props.effectAnimation === "shift" && props.effectDirection === "horizontal" && `
        .shift-row {
            img {
                &:first-child {
                    animation-name: leftShift;
                    // animation-play-state: paused;
                }
        
                &:last-child {
                    animation-name: rightShift;
                    // animation-play-state: paused;
                }
            }
        }
    `}

     ${props => props.isDesktop && props.effectAnimation === "shift" && props.effectDirection === "horizontal" && `
        &:hover {
            .shift-row {
                img {
                    &:first-child {
                        animation-name: leftShift;
                        // animation-play-state: paused;
                    }
            
                    &:last-child {
                        animation-name: rightShift;
                        // animation-play-state: paused;
                    }
                }
            }
        }
    `}

    /* ${props => props.effectAnimation === "blur" && props.effectDirection === "fixed" && `
        .blur-row {
            animation-name: blurAnimation;
            // animation-play-state: paused;
        }
    `} */

    ${props => !props.isDesktop && props.effectAnimation === "blur" && props.effectDirection === "fixed" && `
        .blur-row {
            animation-name: blurAnimation;
            // animation-play-state: paused;
        }
    `}

    ${props => props.isDesktop && props.effectAnimation === "blur" && props.effectDirection === "fixed" && `
        .blur-row:first-of-type  {
            opacity: 1;
        }

        &:hover {
            .blur-row {
                animation-name: blurAnimation;
                // animation-play-state: paused;
            }
        }
    `}
    
    ${props => props.effectDirection === "vertical" && props.effectAnimation === "scroll" && `
        background-position: 0 0;
        background-repeat: repeat-y;
        background-size: 100% auto;

        // &.animation-start {
            animation: scrollVertical 60s infinite linear;
            // animation-play-state: paused;
        // }

        &.animation-end {
            animation-iteration-count: 1;
        }
    `}

    ${props => props.effectDirection === "horizontal" && props.effectAnimation === "fade" && `
        background-position: 0 0;
        background-size: cover;

        // &.animation-start {
            // animation: scrollHorizontal 60s infinite linear;
        // }
    `}

    ${props => props.effectDirection === "vertical" && props.effectAnimation === "fade" && `
        .fade-row {
            img {
                // animation-name: fadeAnimation;
            }
        }
    `}
`;

export const IndexPageFadeBlockButtonStyled = styled(IndexPageBlockButtonStyled)``

export const IndexPageBlurBlockButtonStyled = styled(IndexPageBlockButtonStyled)``

export const IndexPageBlockButtonObjectStyled = styled.object`
    @keyframes animY {
        0% {
            mask-position: center -100%; 
        }

        25% {
            mask-position: center -100%; 
        }

        50% {
            mask-position: center 50%; 
        }

        75% {
            mask-position: center 50%; 
        }

        100% {
            mask-position: center -100%; 
        }
    }

    @keyframes animDesktopY {
        0% {
            mask-position: center -100%; 
        }

        10% {
            mask-position: center -100%; 
        }

        40% {
            mask-position: center 50%; 
        }

        60% {
            mask-position: center 50%; 
        }

        90% {
            mask-position: center -100%; 
        }

        100% {
            mask-position: center -100%; 
        }
    }

    @keyframes animX {
        0% {
            mask-position: 0% 100%;
        }

        25% {
            mask-position: 0% 100%;
        }

        50% {
            mask-position: 100% 100%;
        }

        75% {
            mask-position: 100% 100%;
        }

        100% {
            mask-position: 200% 100%;
        }
    }

    @keyframes animDesktopX {
        0% {
            mask-position: 0% 100%;
        }

        10% {
            mask-position: 0% 100%;
        }

        40% {
            mask-position: 100% 100%;
        }

        60% {
            mask-position: 100% 100%;
        }

        90% {
            mask-position: 200% 100%;
        }

        100% {
            mask-position: 200% 100%;
        }
    }

    @keyframes radialAnim {
        0% {
            mask-size: 0%;
        }

        25% {
            mask-size: 0%;
        }

        50% {
            mask-size: 500%;
        }

        75% {
            mask-size: 500%;
        }

        100% {
            mask-size: 0%;
        }
    }

    @keyframes rectAnim {
        0% {
            mask-size: 0% 0%;
        }

        25% {
            mask-size: 0% 0%;
        }

        50% {
            mask-size: 300% 400%;
        }

        75% {
            mask-size: 300% 400%;
        }

        100% {
            mask-size: 0% 0%;
        }
    }

    @keyframes scrollHorizontalResult {
        from {
            background-position-x: -180px;
        }

        to {
            background-position-x: 1500vw;
        }
    }

    &.wide {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        background-position: 0 0;
        mask-image: url(/assets/images/mask-rect-outline.svg);
        mask-size: 0% 500px;
        mask-position: center center;
        mask-repeat: no-repeat;

        // &.animation-start {
            animation: rectAnim 5s infinite linear;
            // animation-play-state: paused;
        // }

        &.animation-end {
            animation-iteration-count: 1;
        }
    }

    &.normal {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        background-repeat: no-repeat;
        mask: ${props => props.vertical ? "url(/assets/images/mask-rect.svg)" : "linear-gradient(to left, white 50%, transparent 50%)"};
        mask-size: ${props => props.vertical ? "250%" : "200% 100%"};
        mask-repeat: ${props => props.vertical ? "no-repeat" : "repeat"};
        mask-position: ${props => props.vertical ? "center 50%" : "100% 100%"};

        ${props => props.fade && !props.toggle && `
            mask-image: url(/assets/images/mask-circle.svg);
            mask-size: 500%;
            mask-position: center center;
            mask-repeat: no-repeat;
        `}

        ${props => props.isDesktop && props.vertical && `
           &:hover {
                animation: animDesktopY 4s infinite linear;
            }
        `}

        ${props => props.isDesktop && !props.vertical && `
           &:hover {
                animation: animDesktopX 5s infinite linear;
            }
        `}

        ${props => props.isDesktop && props.fade && !props.toggle && `
            &:hover {
                animation: radialAnim 3s infinite linear;
            }
        `}

        ${props => !props.isDesktop && props.vertical && `
            animation: animY 4s infinite linear;
        `}

        ${props => !props.isDesktop && !props.vertical && `
            animation: animX 5s infinite linear;
        `}

        ${props => !props.isDesktop && props.fade && !props.toggle && `
            animation: radialAnim 3s infinite linear;
        `}

        // &.animation-start {
            /* animation: ${props => props.vertical ? "animY 4s infinite linear" : "animX 5s infinite linear"}; */

            /* ${props => props.fade && !props.toggle && `
                animation: radialAnim 3s infinite linear;
            `} */
    
            // animation-play-state: paused;

            &.animation-end {
                animation-iteration-count: unset;
                animation-fill-mode: forwards;
            }
        // }

        ${props => props.isDesktop && props.fade && props.toggle && `
            ${IndexPageFadeBlockButtonStyled}:hover & {
                @keyframes fadeToggleAnim {
                    0% {
                        opacity: 1;
                    }
                    ${props.keyframes}
                    100% {
                        opacity: 0;
                    }
                }

                mask-image: url(/assets/images/mask-circle.svg);
                opacity: 0;

                &:first-child {
                    opacity: 1;
                }

                animation: fadeToggleAnim infinite;
            }
        `}

        ${props => !props.isDesktop && props.fade && props.toggle && `
            @keyframes fadeToggleAnim {
                0% {
                    opacity: 1;
                }
                ${props.keyframes}
                100% {
                    opacity: 0;
                }
            }

            mask-image: url(/assets/images/mask-circle.svg);
            opacity: 0;

            &:first-child {
                opacity: 1;
            }

            animation-name: fadeToggleAnim;
        `}

        /* ${props => props.fade && props.toggle && `
            @keyframes fadeToggleAnim {
                0% {
                    opacity: 1;
                }
                ${props.keyframes}
                100% {
                    opacity: 0;
                }
            }

            mask-image: url(/assets/images/mask-circle.svg);
            opacity: 0;

            &:first-child {
                opacity: 1;
            }

            animation-name: fadeToggleAnim;
        `} */
    }
`;

export const IndexPageBlockButtonTextStyled = styled.p`
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    color: #fff;
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: calc(100% - 20px);
    z-index: 3;
    opacity: 0.5;
`;

export const IndexPageBlockShiftRowStyled = styled.div`
    @keyframes leftShift {
        0% { 
            transform: translateX(-100%);
            opacity: 0;
            filter: blur(10px); 
        }
        ${props => props.keyframes}
        100% { 
            transform: translateX(0);
            opacity: 0;
            filter: brightness(50%); 
        }
    }

    @keyframes rightShift {
        0% { 
            transform: translateX(100%);
            opacity: 0;
            filter: blur(10px); 
        }
        ${props => props.keyframes}
        100% { 
            transform: translateX(0);
            opacity: 0;
            filter: brightness(50%); 
        }
    }

    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
        height: 100%;
        width: calc(50% - 2px);
        animation-duration: var(--animation-duration);
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-delay: var(--animation-delay); 

        &:first-child {
            transform: translateX(-100%);
        }

        &:last-child {
            transform: translateX(100%);
        }
    }

    &:nth-child(2) {
        img {
            transform: translateX(0);
            opacity: 1;
            filter: blur(0); 
        }
    }
`;

export const IndexPageBlockBlurRowStyled = styled.div`
    @keyframes blurAnimation {
        0% { 
            filter: blur(10px);
            opacity: 0; 
        }
        ${props => props.keyframes}
        100% { 
            filter: blur(10px); 
            opacity: 0; 
        }
    }

    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    animation-duration: var(--animation-duration);
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-delay: var(--animation-delay); 

    img {
        height: 100%;
        width: 100%;
    }
`;

export const IndexPageBlockFadeRowStyled = styled.div`
    @keyframes toggleCardFade {
        0% {
            opacity: 1; 
        }
        ${props => props.keyframes}
        100% {
            opacity: 0; 
        }
    }

    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0; 
    &:nth-child(2) {
        opacity: 1;
    }

    ${props => !props.isDesktop && `
        animation: toggleCardFade var(--animation-duration) linear infinite var(--animation-delay);
    `}
    
    // &.animation-start {
        /* animation: toggleCardFade var(--animation-duration) linear infinite var(--animation-delay); */
    // }

    .mask {
        @keyframes animYFade {
            0% {
                mask-position: center 200%; 
            }

            ${props => props.keyframesMask}

            100% {
                mask-position: center 200%; 
            }
        }

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        background-repeat: no-repeat;
        mask: url(/assets/images/mask-rect.svg);
        mask-size: 200%;
        mask-repeat: no-repeat;
        mask-position: center 200%;

        ${props => !props.isDesktop && `
            animation: animYFade var(--animation-duration) linear infinite var(--animation-delay-mask);
        `}

        // &.animation-start {
            /* animation: animYFade var(--animation-duration) linear infinite var(--animation-delay-mask); */
            // animation-play-state: paused;
        // }

        img {
            height: 100%;
            width: 100%;
            animation-duration: var(--animation-duration);
            animation-timing-function: linear;
            animation-iteration-count: infinite;
            animation-delay: var(--animation-delay); 
        }
    }

    ${props => props.isDesktop && `
        ${IndexPageBlockButtonStyled}:hover & {
            animation: toggleCardFade var(--animation-duration) linear infinite var(--animation-delay);

            .mask {
                animation: animYFade var(--animation-duration) linear infinite var(--animation-delay-mask);
            }
        }
    `}

    &:nth-child(1) {
        .mask {
            mask-position: center 10%;
        }
    }
`;

export const IndexPageBlockFadeCircleRowStyled = styled.div`
    @keyframes toggleCardFadeCircle {
        0% {
            opacity: 1; 
        }
        ${props => props.keyframes}
        100% {
            opacity: 0; 
        }
    }

    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0; 

    // &.animation-start {
        /* animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay); */
    // }

    ${props => props.isDesktop && `
        &:hover {
            animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay);
        }
    `}

    ${props => !props.isDesktop && `
        animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay);
    `}

    .mask {
        @keyframes radialAnimFade {
            0% {
                mask-position: center 10px;
                mask-size: 0%;
            }
            ${props => props.keyframesMask}
            100% {
                mask-position: center 10px;
                mask-size: 0%;
            }
        }

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        background-repeat: no-repeat;
        mask-image: url(/assets/images/mask-circle.svg);
        mask-size: 0%;
        mask-position: center 10px;
        mask-repeat: no-repeat;

        ${props => props.isDesktop && `
            &:hover {
                animation: radialAnimFade var(--animation-duration) linear infinite var(--animation-delay-mask);
            }
        `}

        ${props => !props.isDesktop && `
            animation: radialAnimFade var(--animation-duration) linear infinite var(--animation-delay-mask);
        `}

        // &.animation-start {
            /* animation: radialAnimFade var(--animation-duration) linear infinite var(--animation-delay-mask); */
            // animation-play-state: paused;
        // }
        
        img {
            height: 100%;
            width: 100%;
        }
    }

    &:nth-child(2) {
        opacity: 1;

        .mask {
            mask-size: 300%;
            mask-position: center -300px;
        }
    }
`;

export const IndexPageBlockFadeCircleCenterRowStyled = styled.div`
    @keyframes toggleCardFadeCircle {
        0% {
            opacity: 1; 
        }
        ${props => props.keyframes}
        100% {
            opacity: 0; 
        }
    }

    @keyframes scaleImage {
        0% {
            scale: 2; 
        }
        ${props => props.keyframesScale}
        100% {
            scale: 1; 
        }
    }

    width: 100%;
    height: 232px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0; 
    overflow: hidden;
    will-change: transform;


    ${props => !props.isDesktop && `
        animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay);
    `}

    // &.animation-start {
        /* animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay); */
    // }

    >img {
        /* animation: scaleImage var(--animation-duration) ease infinite var(--animation-delay-mask); */

        ${props => !props.isDesktop && `
            animation: scaleImage var(--animation-duration) ease infinite var(--animation-delay-mask);
        `}
    }

    .mask {
        @keyframes radialAnimFadeCenter {
            0% {
                mask-position: center;
                mask-size: 300%;
            }
            ${props => props.keyframesMask}
            100% {
                mask-position: center;
                mask-size: 300%;
            }
        }

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        background-size: cover;
        background-repeat: no-repeat;
        mask-image: url(/assets/images/mask-circle1.svg);
        mask-size: 300%;
        mask-position: center;
        mask-repeat: no-repeat;

        ${props => !props.isDesktop && `
            animation: radialAnimFadeCenter var(--animation-duration) linear infinite var(--animation-delay-mask);
        `}

        // &.animation-start {
            /* animation: radialAnimFadeCenter var(--animation-duration) linear infinite var(--animation-delay-mask); */
            // animation-play-state: paused;
        // }
        
        img {
            height: 100%;
            width: 100%;
        }
    }

    ${props => props.isDesktop && `
       ${IndexPageBlockButtonStyled}:hover & {
            animation: toggleCardFadeCircle var(--animation-duration) linear infinite var(--animation-delay);

            >img {
                animation: scaleImage var(--animation-duration) ease infinite var(--animation-delay-mask);
            }

            .mask {
                animation: radialAnimFadeCenter var(--animation-duration) linear infinite 0s;
            }
        }
    `}

    &:nth-child(1) {
        opacity: 1;
    }
`;

export const IndexPageD22BlockStyled = styled.div`
  @keyframes scrollVerticalBg {
    from {
        background-position-y: -35%;
    }

    to {
        background-position-y: 550%;
    }
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => props.bgImage};
  background-size: 100%;
  background-repeat-y: repeat;
  background-position-y: -35%;
  position: relative;
  width: 100%;
  padding-top: 100px;
  margin-bottom: 24px;
  animation: scrollVerticalBg 60s infinite linear;

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: linear-gradient(#051320, transparent 10%, #051320);
  }
`;

export const IndexPageD22BlockContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    margin-bottom: 16px;

    h1 {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      margin-bottom: 16px;
    }


    button {
      position: relative;
      font-weight: bold;
      font-size: 14px;
      height: 32px;
      max-width: 100px;

      svg {
        position: absolute;
        top: -12px;
        right: -8px;
        width: 20px;
        height: 26px;
      }
    }
`;

export const IndexPageD22BlockImageContainerStyled = styled.div`
  width: 84px;
  height: 84px;
  border: 2px solid #fff;
  border-radius: 50%;
  margin-bottom: 4px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const IndexPagePreviewWebBlockContainerStyled = styled.div`
    padding: 44px 16px 24px;

    h1 {
        font-size: 22px;
        font-weight: 700;
        line-height: 33px;
        text-align: center;
        margin-bottom: 60px;
    }

    @media all and (max-width: 991px) {
        padding-top: 33px;
        padding-bottom: 48px;

        h1 {
            font-size: 20px;
            line-height: 30px;
            margin-bottom: 48px;
        }
    }
`;

export const IndexPagePreviewWebBlockContentContainerStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 112px;
`;

export const IndexPagePreviewWebBlockContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px dashed #EDC743;
    border-radius: 15px;
    padding: 30px;
    box-sizing: border-box;
    max-width: 360px;
    width: 100%;

    h2 {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-align: center;
        margin-bottom: 20px;
    }

    p {
        font-size: 10px;
        font-weight: 400;
        line-height: 15px;
        text-align: center;
        color: #666;

        a {
            color: #666;
            text-decoration: underline;
        }
    }

    button {
        font-size: 14px;
        font-weight: 700;
        line-height: 18px;
        color: #000;
        background: #EDC743;
        border-radius: 15px;
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 9px;
        margin-bottom: 10px;

        svg {
            width: 18px;
            fill: #000;
            margin-top: -5px;
        }

        span {
            * {
                text-transform: capitalize;
            }
        }
    }

    @media all and (max-width: 991px) {
        max-width: 450px;
    }
`;

export const IndexPagePreviewWebBlockImageStyled = styled.div`
    background: url("/assets/images/previewWeb-block/webResult2.webp") 0% 0% / cover no-repeat transparent;
    width: 262px;
    height: 350px;
    position: relative;
    transform: translateZ(0px);
    will-change: transform;
    border-radius: 10px;
    overflow: hidden;

    @media all and (max-width: 991px) {
        display: none;
    }
`

export const IndexPagePreviewWebBlockImageFilterStyled = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: url("/assets/images/previewWeb-block/webResult1.webp") 0% 0% / cover no-repeat transparent;
    mask: linear-gradient(to left, white 50%, transparent 50%) 100% 100% / 200% 100%;
    mask-position: 100% 100%;
    animation: animPrevewBlock 5s infinite linear;

    @keyframes animPrevewBlock {
        0% {
            mask-position: 0% 100%;
        }

        25% {
            mask-position: 0% 100%;
        }

        50% {
            mask-position: 100% 100%;
        }

        75% {
            mask-position: 100% 100%;
        }

        100% {
            mask-position: 200% 100%;
        }
    }
`;
